import React, { PropsWithChildren, useContext, useEffect, useRef, useState } from 'react'
import { View, Text, FlatList } from 'react-native'
import { OptionsItem } from '../../../components/OptionsItem'
import { InitialInputVoiceSearch } from '../../../components/VoiceSearch/InitialInput/InitialInput'
import { ControlServicesContext } from '../../../context/SeaWater/ControlServices/ControlServicesContext'
import { corporateColor } from '../../../theme/colors'
import { useTranslation } from 'react-i18next'

interface Props extends PropsWithChildren {
  getCenterId: (value: { name: string; id: number }) => void
  initialValues?: number
  multiple?: boolean
}
export const Centers = ({ getCenterId: getCenter, initialValues, children, multiple = false }: Props) => {
  const { centers } = useContext(ControlServicesContext)
  const [selectedOption, setSelectedOption] = useState<number | null>(initialValues ?? null)
  const [selectName, setSelectName] = useState('')
  const [search, setSearch] = useState('')
  const [filteredData, setfilteredData] = useState<{ name: string; id: number }[]>([])
  const { t } = useTranslation()
  const handleOptionPress = (item: { name: string; id: number }) => {
    setSelectedOption(item.id === selectedOption ? null : item.id)
    setSelectName(item.name)
  }
  const getSearchValue = (value: string) => setSearch(value)
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (!isFirstRender.current) {
      if (selectedOption !== null) {
        getCenter({ id: selectedOption, name: selectName })
      }
    }
    isFirstRender.current = false
  }, [selectedOption])

  useEffect(() => {
    setfilteredData(
      centers.filter((item: any) => item.name.toLowerCase().includes(search.toLowerCase())),
    )
  }, [search])

  return (
    <View>
      <Text
        style={{ textAlign: 'center', fontWeight: 'bold', color: corporateColor, marginTop: 24 }}
      >
        {t('Selecciona un centro')}
      </Text>
      <InitialInputVoiceSearch
        hasInput
        placeholder={t('BUSCAR CENTRO')}
        getSearchValue={getSearchValue}
      />
      {children}
      <FlatList
        style={{ marginTop: 10 }}
        data={filteredData}
        renderItem={({ item }) => (
          <OptionsItem
            item={item}
            onPress={() => {
              handleOptionPress(item)
            }}
            isSelected={!multiple ? item.id === selectedOption : false}
            circle
          />
        )}
        horizontal
      />
    </View>
  )
}
